import { API_URL, HISTORY_PER_PAGE } from "./config";
import { convertDate, getJson } from "./helper";


export const state = {
    recipe: {},
    search: {
        query: "",
        results: []
    },
    history: {
        results: [],
        historyPerPage: HISTORY_PER_PAGE,
        page: 1
    }

}

export const loadSearchResults = async function (query) {
    try {
        state.search.query = query;
        const data = await getJson(`${API_URL}/recipes?search=${query}`)

        state.search.results = data?.data?.recipes?.map(rec => {
            return {
                id: rec?.id,
                title: rec?.title,
                publisher: rec?.publisher,
                image: rec?.image_url,
            }
        })

    }
    catch (err) {
        console.log(err)
        throw err
    }
}

export const saveToStorage = (id) => {
    const findItem = state?.search?.results?.find?.(el => el?.id === id)
    var existingEntries = JSON.parse(localStorage.getItem("history")) ?? [];

    const createdTime = convertDate(new Date());
    existingEntries.unshift({ ...findItem, createdTime })
    localStorage.setItem("history", JSON.stringify(existingEntries));
    getItemsFromStorage("history");
}
export const getItemsFromStorage = (title) => {
    state.history.results = JSON.parse(localStorage.getItem(title)) ?? [];
}
export const removeItem = (id) => {
    state.history.results = state?.history.results?.filter(el => el?.id !== id);
    localStorage.setItem("history", JSON.stringify(state.history.results))
}

export const historyResultPerPage = page => {
    state.history.page = +page;
    const start = (page - 1) * state.history.historyPerPage;
    const end = (page) * state.history.historyPerPage;
    return state.history.results.slice(start, end)
}